module.exports = __webpack_public_path__ + "images/landing/video-previews/Collaborative_Learning_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Collaborative_Learning_2x.jpg
// module id = 0tvN
// module chunks = 1